import classNames from 'classnames';
import { useStore } from 'stores';
import { X } from 'assets/icons';
import { formatStockName } from 'utils/stock';
import { deleteUserMarketProfile } from 'api/strategy';

export default function TagList() {
  const UserMarketProfile = useStore((state) => state.UserMarketProfile);
  const currentEmail = useStore((state) => state.currentEmail);
  const currentStock = useStore((state) => state.currentStock);
  const setUserMarketProfile = useStore((state) => state.setUserMarketProfile); // 自選策略清單
  const BQMarketName = useStore((state) => state.BQMarketName);
  const setCurrentStock = useStore((state) => state.setCurrentStock);
  const strategyList = useStore((state) => state.strategyList);
  const setCurrentStrategy = useStore((state) => state.setCurrentStrategy);

  async function handleDelete(id) {
    const res = await deleteUserMarketProfile(currentEmail, [id]);
    if (res) {
      setUserMarketProfile(res);
    }
  }

  function handleTagClick(stock) {
    setCurrentStock(BQMarketName.find(({ marketId }) => marketId === stock.MarketId));
    setCurrentStrategy(
      strategyList.find(({ StrategyProfileId }) => StrategyProfileId === stock.StrategyProfileId)
    );
  }

  return (
    <div className="flex space-x-2 my-4 flex-wrap">
      {UserMarketProfile?.map((stock) => (
        <div
          key={`tag_${stock.MarketProfileId}`}
          className={classNames('flex space-x-2 rounded-full text-white py-2 px-4 my-2', {
            'bg-blue': stock.MarketId === currentStock.marketId,
            'bg-blue-light': stock.MarketId !== currentStock.marketId,
          })}
        >
          <span onClick={() => handleTagClick(stock)}>{formatStockName(stock)}</span>
          <X onClick={() => handleDelete(stock.MarketProfileId)} />
        </div>
      ))}
    </div>
  );
}
